import React from 'react';
import { graphql } from 'gatsby';
import ShopTemplate from './shop-template';

const Collection = ({ data, pageContext, location }) => {
  return (
    <ShopTemplate
      collection={data.shopifyCollection}
      parentContext={pageContext}
      type="collection"
      location={location}
      seo={data.shopifyCollection.seo}
      description={data.shopifyCollection.descriptionHtml}
    />
  )
}

export default Collection;

export const collectionQuery = graphql`
  query($id: String) {
    shopifyCollection(id: {eq: $id}) {
      id
      title
      handle
      descriptionHtml
      image {
        altText
        src
      }
      metafields {
        key
        namespace
        value
      }
      isMain: metafield(key: "collection_ismain", namespace: "collection") {
        value
      }
      subs: metafield(key: "collection_subs", namespace: "collection") {
        value
      }
      products {
        createdAt
        title
        handle
        descriptionHtml
        legacyResourceId
        storefrontId
        tracksInventory
        totalInventory
        tags
        shopifyId
        vendor
        productType
        collections {
          title
          handle
        }
        priceRangeV2 {
          maxVariantPrice {
            amount
          }
          minVariantPrice {
            amount
          }
        }
        featuredImage {
          altText
          src
        }
        hasOnlyDefaultVariant
        metafields {
          key
          namespace
          value
        }
        media {
          ... on ShopifyMediaImage {
            image {
              altText
              src
            }
          }
        }
        variants {
          title
          price
          compareAtPrice
          legacyResourceId
          storefrontId
          availableForSale
          selectedOptions {
            name
          }
          media {
            ... on ShopifyMediaImage {
              image {
                altText
                src
              }
            }
          }
        }
      }
      seo {
        title
        description
      }
    }
  }
`
